export default (function () {
  return {
    link: function link(scope, element) {
      element.one('load', function () {
        element[0].contentWindow.postMessage(scope.sendWidgetData, element[0].src);
        scope.onLoadCallback();
      });
      element.one('fail', function () {
        scope.onFailCallback();
      });
    },
    restrict: 'A',
    scope: {
      onFailCallback: '&',
      onLoadCallback: '&',
      sendWidgetData: '<'
    }
  };
});